<div class="period-files-panel">
  <div class="period-files-panel__header">
    <span class="period-files-panel__title">{{ headerLabel() }}</span>
    <span
      class="period-files-panel__badge"
      [class]="'period-files-panel__badge--' + cellStateClass()">
      {{ cellStateLabel[cellState()] }}
    </span>
  </div>

  @if (hasDuplicates()) {
    <div class="period-files-panel__duplicate-warning">
      <span class="period-files-panel__duplicate-icon" aria-hidden="true">⚠</span>
      @if (isRevenue()) {
        <!-- Faturamento (card 3700): não vale o "último enviado"; a regra vem escrita do backend (`ruleText`). -->
        <span data-testid="revenue-rule-text">
          {{ period().files.length }} arquivos neste mês.
          @if (ruleText()) {
            {{ ruleText() }}
          }
          @if (consideredFile(); as considered) {
            Vale: {{ considered.fileName }}.
          }
        </span>
      } @else {
        <span>
          {{ period().files.length }} arquivos {{ isAnnual() ? 'neste ano' : 'neste mês' }}. O sistema
          considera apenas o último enviado ({{ consideredFile()?.fileName }}); os anteriores ficam
          apenas como histórico.
        </span>
      }
    </div>
  }

  @if (period().files.length > 0) {
    <div class="period-files-panel__files">
      @for (file of period().files; track trackFile($index, file)) {
        <div class="period-files-panel__file-row">
          @if (file.isPending) {
            <!--
              Submissão ainda sem extração (Task 5B): não há arquivo processado para pré-visualizar nem
              extração para excluir por aqui, então o nome não é clicável e não há botão de remover — a
              decisão (aprovar/rejeitar) é tomada onde o documento é analisado, não nesta tela.
            -->
            <span class="period-files-panel__file-name period-files-panel__file-name--pending">
              {{ file.fileName }}
            </span>
          } @else {
            <button
              type="button"
              class="period-files-panel__file-name"
              title="Visualizar arquivo"
              (click)="openFile(file.extractionId)">
              {{ file.fileName }}
            </button>
          }
          @if (file.isPending) {
            <!--
              Rodada de correção 1 (Task 5B): sem o status de processamento aqui — `file.status` vem
              sempre "InQueue" para item pendente (não existe RevenueStatementStatus real ainda), e
              mostrá-lo ao lado de "Aguardando aprovação" contradiz o próprio texto ("Na fila" soa como
              extração em andamento, e não há extração nenhuma).
            -->
            <span class="period-files-panel__file-consideration">Aguardando aprovação</span>
          } @else {
            <span class="period-files-panel__file-status">{{ fileStatusLabel[file.status] }}</span>
            <span
              class="period-files-panel__file-consideration"
              [class.period-files-panel__file-consideration--considered]="file.isConsidered">
              {{ file.isConsidered ? 'Considerado' : 'Substituído' }}
            </span>
            <button
              type="button"
              class="period-files-panel__file-remove"
              title="Remover arquivo"
              aria-label="Remover arquivo"
              (click)="removeFile(file.extractionId)">
              ✕
            </button>
          }
        </div>
      }
    </div>
  } @else {
    <p class="period-files-panel__empty">{{ emptyMessage() }}</p>
  }
</div>
